import React from "react";
import styled from "styled-components";

export default styled.input`
    margin-bottom: 20px;
`;